import { base64UrlDecode } from './base64UrlDecode';

/**
 * @description
 * This function decodes a JWT token and returns its payload.
 *
 * @template T - The type of the payload.
 * @param {string} token - The JWT token to decode.
 * @returns {T} The payload of the JWT token.
 *
 * @example
 * const payload = decodeJwtToken<{ foo: string }>('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmb28iOiJiYXIiLCJpYXQiOjE1MTYyMzkwMjJ9.tbVdx7ZEXA9W0t4MMA56GkJJlTPyG7C1mC6YfIgEgD8');
 * console.log(payload); // Output: { foo: 'bar' }
 */
export const decodeJwtToken = <T = unknown>(token: string): T => {
    const base64Url = token.split('.')[1];

    return JSON.parse(base64UrlDecode(base64Url));
};
